// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { PrimaryTemplate } from 'components/templates/PrimaryTemplate';
import EmissionQRScanning from 'components/organisms/EmissionQRScanning';
import { useTranslation } from 'react-i18next';

const EmissionQRScan = () => {
  const { t } = useTranslation();

  return (
    <PrimaryTemplate h1={t('emission_qr_scanning.title')}>
      <EmissionQRScanning />
    </PrimaryTemplate>
  );
};

export default EmissionQRScan;
